import Controller from '@ember/controller';
import { action } from '@ember/object';
import { service } from '@ember/service';

import * as Sentry from '@sentry/ember';
import { dropTask } from 'ember-concurrency';
import { variation } from 'ember-launch-darkly';

import { MainLayout } from 'register-partners-js/react/components/layouts/main';
import { ErrorInfo } from 'register-partners-js/utils/error-info';

import styles from './styles.module.css';

export default class BusinessFinancesController extends Controller {
  mainLayout = MainLayout;

  @service store;
  @service segment;
  @service router;

  @action
  handleGoBack() {
    let registrationId = this.model.registration.id;
    let organization = this.model.registration.organization;
    let isFrenchNewActivityScreenEnabled =
      organization.get('legalCountry') === 'FR' &&
      variation('feature--boolean-fr-new-activity-screen');

    if (isFrenchNewActivityScreenEnabled) {
      return this.router.transitionTo('react', `registrations/${registrationId}/company-activity`);
    } else {
      return this.router.transitionTo('react', `registrations/${registrationId}/business-activity`);
    }
  }

  handleSubmit = dropTask(async organization => {
    try {
      await organization.save();
    } catch (error) {
      let errorInfo = ErrorInfo.for(error);
      if (errorInfo.shouldSendToSentry) {
        Sentry.captureException(error, {
          tags: { flow: 'register-partners', step: 'business-finances' },
        });
      }
      return;
    }
    // To be removed when backend removes `features` property from organization PATCH
    await this.store.findAll('organization');

    let trackedFields = {
      declared_yearly_estimated_transaction_volume: organization.yearlyTransactionVolume,
      declared_maximum_single_payment_amount: organization.maxSinglePaymentAmount,
    };

    if (organization.annualTurnover) {
      trackedFields.declared_annual_turnover = organization.annualTurnover;
    }

    this.segment.identify(trackedFields);
    this.segment.track('onboarding_partner_register_financial_info_submitted', trackedFields);

    this.router.transitionTo(
      'react',
      'registrations/' + this.model.registration.id + '/owner-info'
    );
  });
  styles = styles;
}
